import { render, staticRenderFns } from "./DelPurchasingRecord.vue?vue&type=template&id=3a7641f2&scoped=true&"
import script from "./DelPurchasingRecord.vue?vue&type=script&lang=js&"
export * from "./DelPurchasingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7641f2",
  null
  
)

export default component.exports